/* =================== CADASTRA PDF =================== */
(function () {
  "use strict";

  // Exibe o modal
  $("[data-anexar-pdf]").on("click", function (ev) {
    ev.preventDefault();
    const anuncioId = $(this).data("anexar-pdf");
    $("#anuncio-cad-pdf-id").val(anuncioId);
    openModal("modal-anexar-pdf");
  });

  // Envia o formulário
  var enviando_formulario = false;
  $("#form-anexar-pdf").on("submit", function (e) {
    e.preventDefault();

    var obj = this;
    var form = $(obj);
    var submit_btn = form.find("#cadastrar_pdf");
    var submit_btn_text = submit_btn.text();
    var dados = new FormData(obj);

    function volta_submit() {
      submit_btn.attr("disabled", false);
      submit_btn.text(submit_btn_text);
      enviando_formulario = false;
      hideLoading();
    }

    if (!enviando_formulario) {
      $.ajax({
        url: form.attr("action"),
        type: form.attr("method"),
        data: dados,
        processData: false,
        cache: false,
        contentType: false,
        beforeSend: function () {
          showLoading();
          enviando_formulario = true;
          submit_btn.attr("disabled", true);
          submit_btn.text("Aguarde...");
        },
        success: function (data) {
          console.log(data);
          volta_submit();
          if (data == "ok") {
            $("#form-anexar-pdf .campo").val("");
            closeModal("modal-anexar-pdf");
            showAlert("Sucesso", "Arquivo cadastrado com sucesso.", "success");
          } else {
            showAlert("Erro", "Não foi possível cadastrar o arquivo.", "error");
          }
        },
        error: function (xhr, type, exception) {
          volta_submit();
          showAlert("Erro", "Não foi possível cadastrar o arquivo.", "error");
          console.log("ajax error response type " + type);
        },
      });
    }
  });
})();
